import React from "react";
import { Row, Col, Typography, Button } from "antd";
import { gaEvent } from "analytics/analytics";
import * as GA from "constants/analytics";

const { Title } = Typography;

export default function FloatingCard({
  collectionDetails,
  selectedProdutcs,
  loading,
  handleView,
}) {
  return (
    <>
      {collectionDetails && (
        <Row justify="end" style={{ bottom: 0, right: 0, position: "sticky", pointerEvents:'none'}}>
          <Col
            span={6}
            style={{
              padding: "1rem",
              margin: "1rem",
              marginRight: "-2rem",
              borderRadius: "8px",
              background: "rgba(0, 0, 0, .8) ",
              
            }}
          >
            <Row justify="space-between" align="middle">
              <Col>
                <Title
                  level={4}
                  style={{
                    color: "white",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "10rem",
                  }}
                >
                  {" "}
                  {collectionDetails?.collection_name}{" "}
                </Title>
              </Col>

              <Col>
                <Button
                  onClick={() => {
                    handleView();
                    gaEvent(
                      GA.EVENT.CLICK,
                      GA.CATEGORY.CREATE_COLLECTION,
                      GA.DESCRIPTION.CREATE_COLLECTION_VIEW_BUTTON
                    );
                  }}
                  type="primary"
                  loading={loading}
                  style={{pointerEvents:'auto'}}
                >
                  View
                </Button>
              </Col>
            </Row>

            {selectedProdutcs && selectedProdutcs.length > 0 ? (
              <Row align="middle">
                {selectedProdutcs[0] && (
                  <img
                    style={{ borderRadius: 8, marginRight: "0.5rem" }}
                    alt="product name"
                    src={
                      selectedProdutcs?.[0]?.product_images?.[0]
                        ? `${process.env.REACT_APP_DIRECTUS}assets/${selectedProdutcs?.[0]?.product_images?.[0]?.directus_files_id}?fit=cover&width=50&height=50&quality=90`
                        : "https://via.placeholder.com/50x50.png"
                    }
                  />
                )}
                {selectedProdutcs[1] && (
                  <img
                    style={{ borderRadius: 8, marginRight: "0.5rem" }}
                    alt="product name"
                    src={
                      selectedProdutcs?.[1]?.product_images?.[0]
                        ? `${process.env.REACT_APP_DIRECTUS}assets/${selectedProdutcs?.[1]?.product_images?.[0]?.directus_files_id}?fit=cover&width=50&height=50&quality=90`
                        : "https://via.placeholder.com/50x50.png"
                    }
                  />
                )}
                {selectedProdutcs[2] && (
                  <img
                    style={{ borderRadius: 8, marginRight: "0.5rem" }}
                    alt="product name"
                    src={
                      selectedProdutcs?.[2]?.product_images?.[0]
                        ? `${process.env.REACT_APP_DIRECTUS}assets/${selectedProdutcs?.[2]?.product_images?.[0]?.directus_files_id}?fit=cover&width=50&height=50&quality=90`
                        : "https://via.placeholder.com/50x50.png"
                    }
                  />
                )}
                {selectedProdutcs.length > 3 && (
                  <span level={5} style={{ color: "white" }}>
                    {" "}
                    {`+ ${selectedProdutcs.length - 3} more`}{" "}
                  </span>
                )}
              </Row>
            ) : null}
          </Col>
        </Row>
      )}
    </>
  );
}
